// KPI strip — conversion, sessions to orders, add-to-cart and velocity at
// account level, as the PRD's page layout lists them.
//
// It fetches nothing. Each figure already arrives with the card that explains
// it, so the page hands those payloads here rather than paying for the same
// reads twice. A tile shows a dash until its card has loaded.
import React from 'react';

import local from '../ProductPerformance.module.css';

const percent = (ratio) =>
  ratio === null || ratio === undefined ? null : `${(ratio * 100).toFixed(2)}%`;

const QUALITY_LABEL = { estimated: 'est.', fallback: 'default' };

const Tile = ({ label, value, detail, title, quality }) => (
  <div title={title}>
    <div className={local.ratioLabel}>{label}</div>
    <div className={local.ratioValue}>
      {value ?? <span className={local.blank}>—</span>}
      {value && quality && (
        <span className={quality === 'fallback' ? local.qualityFallback : local.qualityEst}>
          {QUALITY_LABEL[quality] || quality}
        </span>
      )}
    </div>
    {detail && <div className={local.muted}>{detail}</div>}
  </div>
);

const KpiStrip = ({ funnel, conversion, table }) => {
  const totals = conversion?.totals;
  const cart = conversion?.add_to_cart;
  const perDay = table?.account_velocity?.per_day;

  return (
    <section className={local.card}>
      <div className={local.cardHead}>
        <h2 className={local.cardTitle}>At a glance</h2>
      </div>
      <div className={local.ratios}>
        <Tile
          label="Conversion"
          value={percent(totals?.unit_conversion)}
          detail={totals ? `${percent(totals.order_conversion) ?? '—'} by orders` : null}
        />
        <Tile
          label="Sessions to orders"
          value={percent(funnel?.funnel?.sessions_to_orders)}
        />
        {/* Never measured: Amazon publishes no cart data for this marketplace,
            so a value only appears with the label saying what it is. */}
        <Tile
          label="Add to cart"
          value={percent(cart?.rate)}
          quality={cart?.quality}
          title={cart?.reason}
          detail={cart && cart.rate === null ? 'Not reported, hover for why' : null}
        />
        <Tile
          label="Velocity"
          value={perDay === null || perDay === undefined ? null : `${perDay.toFixed(0)} units / day`}
          detail={table ? 'Across the catalogue' : null}
        />
      </div>
    </section>
  );
};

export default KpiStrip;
